import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=64051002&"
import script from "./edit-client.js?vue&type=script&lang=js&"
export * from "./edit-client.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports